<template>
    <div class="solution-main">
        <!-- 头部 -->
      <headers></headers>
        <section class="ban ban2">
            <div class="col">
                <div>
                    <h1 class="title1">主场解决方案</h1>
                    <p>为主场企业提供高效率、低成本、创新增收的数字化升级解决方案。</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col box-3" style="padding-top: 50px;">
                <h4 class="title3" style="margin-bottom: 30px;">核心优势</h4>
                <div class="list-hxys">
                    <dl>
                        <dt>数字化升级</dt>
                        <dd>专业的技术支撑<br>
                            高效的流程设计<br>
                            丰富的经验积累<br>
                            广泛的实践运用</dd>
                    </dl>
                    <dl>
                        <dt>安全高效</dt>
                        <dd>严格的权限划分<br>
                            智能的审图助⼿<br>
                            直观的数据呈现<br>
                            ⾼效的巡查⼯具</dd>
                    </dl>
                    <dl>
                        <dt>专业服务</dt>
                        <dd>先进的运营理念<br>
                            专业的运营经验<br>
                            专业的研发团队<br>
                            一对一服务护航</dd>
                    </dl>
                </div>
            </section>
            <section class="col box-3" style="">
                <h4 class="title3" style="margin-bottom: 70px;">应用场景</h4>
                <div class="box-yycj">
                    <ul class="ul1" id="list-btn">
                        <li class="active">降本增效</li>
                        <li class="">合作共赢</li>
                    </ul>
                    <div class="div1">
                        <p class="p1" id="_title" style="border-bottom: none;">主场云：PC+小程序</p>
                        <el-link :underline="false" href="activity">查看合作共赢计划</el-link>
                        <ul class="ul2" id="_list">
                            <li>·在线审阅图纸订单</li>
                            <li>·展台数据⼀键导出</li>
                            <li>·“零接触”现场服务</li>
                            <li>·安全巡查移动应⽤</li>
                            <li>·更多</li>
                        </ul>
                        <!-- <a id="" class="btn-more" href="./activity.html">了解合作共赢计划 ></a> -->
                    </div>
                    <div class="div2">
                        <div class="img-box">
                            <img id="_img" :src="require(`@/images/${image}`)" alt="">
                            <a href="./activity.html" style="top: 0; bottom:0; left:0;right:0"></a>
                        </div>
                    </div>
                </div>
                


            </section>

            <section class="col box-3">
                <h4 class="title3" style="margin-bottom: 50px;">合作伙伴</h4>
                <ul class="brand-list">
                    <li><img src="../images/logo/36中食.jpg" alt=""></li>
                    <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                    <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                    <li><img src="../images/logo/39零售.jpg" alt=""></li>
                    <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                    <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                    <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                    <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                    <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                    <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                    <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                </ul>
            </section>

            
        </div>
        <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 26px;">服务联系</h4>
        <div class="box-fwlx">
            <section class="col box-3 ">
                <div class="box-fwlx-con">
                    <div class="div1">
                        <p>企微客服</p>
                        <img src="../images/img-kf.png" alt="">
                        <p>首席客服热线</p>
                        <span>010-86460766-861</span>
                    </div>
                    
                        <ul class="ul1">
                            <form id="form-zx2" action="">
                                <li class="li1">
                                    <label for="">公司名称</label>
                                    <input name="compnay" type="text" maxlength="50">
                                </li>
                                <li class="li1">
                                    <label for="">所在行业</label>
                                    <input name="industry" type="text" maxlength="30">
                                </li>
                                <li class="li1">
                                    <label for="">您的姓名</label>
                                    <input name="username" type="text" maxlength="20">
                                </li>
                                <li class="li1">
                                    <label for="">手机号码</label>
                                    <input name="phone" type="text">
                                </li>
                                <li>
                                    <label for="">咨询需求</label>
                                    <textarea name="content" id="" maxlength="200"></textarea>
                                </li>
                                <li>
                                    <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                </li>
                            </form>
                        </ul>
                    
                </div>
            </section>
        </div>
         <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
        import $ from 'jquery';
  import headers from '@/common/header';
  import footers from '@/common/Footer';
  import contact from '@/components/contact';
  export default {
    components: {
      headers,
      footers,
      contact
    },
    data() {
      return {
        list :[{
            label: '降本增效',
            title: '主场云+合作共赢',
            con: ['·在线审阅图纸订单','·展台数据⼀键导出','·“零接触”现场服务','·安全巡查移动应⽤','·更多'],
            img: 'img-3-4.png',
            url: ''
        },{
            label: '合作共赢',
            title: '',
            con: ['·展台保险集采优惠','·推荐搭建商合作','·平台收益分成','·更多平台分利请联系我们'],
            img: 'img-3-9.png',
            url: ''
        }],
        image:'img-3-4.png'
    }
},
mounted() {
        let that = this
        $('#list-btn>li').on('click',function(){
            $(this).addClass('active').siblings('li').removeClass('active')
            var _index = $(this).index()
            var item = that.list[_index]
            $('#_title').text(item.title)
            var html = ''
            for(var i=0,j=item.con.length; i<j; i++){
                html += '<li>'+item.con[i]+'</li>'
            }
            $('#_list').html(html)
            // $('#_img').attr('src',item.img)
            that.image = item.img
            // $('#_more').attr('href',item.url)

            if(_index == 1){
                $('#_title').hide()
                $('#_more').show()
                $('.img-box a').show()
            }else{
                $('#_title').show()
                $('#_more').hide()
                $('.img-box a').hide()
            }
        }) 
    }
}

    </script>


// WEBPACK FOOTER //
// src/page/solution-2.vue